export enum AppTypes {
    SET_PLATFORM = 'SET_PLATFORM',
    RELOAD_PAGE = 'RELOAD_PAGE',
    CLOSE_NAV = 'CLOSE_NAV',
    OPEN_NAV = 'OPEN_NAV',
    CLOSE_ACCOUNT_MENU = 'CLOSE_ACCOUNT_MENU',
    OPEN_ACCOUNT_MENU = 'OPEN_ACCOUNT_MENU',
    CLOSE_UPDATER_DRAWER = 'CLOSE_UPDATER_DRAWER',
    OPEN_UPDATER_DRAWER = 'OPEN_UPDATER_DRAWER',
    ON_CLIENT_MOUNT = 'ON_CLIENT_MOUNT',
    SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS',
    ADD_NOTIFICATION = 'ADD_NOTIFICATION',
    REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
    SET_ACCEPTED_AGE_GATE = 'SET_ACCEPTED_AGE_GATE',
    APP_TRACK_EVENT = 'APP_TRACK_EVENT',
    SET_CLIENT_EXPIRED = 'SET_CLIENT_EXPIRED',
    SET_THEME = 'SET_THEME'
}

// @depreciated
export const TYPES = AppTypes;

export interface IsLauncherPayload {
    isLauncher: boolean;
}

export interface IsOnlinePayload {
    isOnline: boolean;
}

export interface PlatformPayload {
    platform: string;
}

export interface NotificationPayload {
    notification: Notification;
}

export interface TrackEventPayload {
    interactionType: string;
    eventCategory: string;
    eventAction: string;
    eventLabel: string;
    eventValue: string;
}

export interface AppAction {
    type: AppTypes;
    payload?:
        | IsLauncherPayload
        | IsOnlinePayload
        | PlatformPayload
        | NotificationPayload
        | TrackEventPayload;
}

export default {
    // @depreciated
    TYPES,

    reloadPage: (): AppAction => ({
        type: TYPES.RELOAD_PAGE
    }),

    closeNav: (): AppAction => ({
        type: TYPES.CLOSE_NAV
    }),

    openNav: (): AppAction => ({
        type: TYPES.OPEN_NAV
    }),

    closeAccountMenu: (): AppAction => ({
        type: TYPES.CLOSE_ACCOUNT_MENU
    }),

    openAccountMenu: (): AppAction => ({
        type: TYPES.OPEN_ACCOUNT_MENU
    }),

    closeUpdaterDrawer: (): AppAction => ({
        type: TYPES.CLOSE_UPDATER_DRAWER
    }),

    openUpdaterDrawer: (): AppAction => ({
        type: TYPES.OPEN_UPDATER_DRAWER
    }),

    onClientMount: (isLauncher: boolean): AppAction => ({
        type: TYPES.ON_CLIENT_MOUNT,
        payload: {isLauncher}
    }),

    setConnectionStatus: (isOnline: boolean): AppAction => ({
        type: TYPES.SET_CONNECTION_STATUS,
        payload: {isOnline}
    }),

    setPlatform: (platform: string): AppAction => ({
        type: TYPES.SET_PLATFORM,
        payload: {platform}
    }),

    addNotification: (notification: Notification): AppAction => ({
        type: TYPES.ADD_NOTIFICATION,
        payload: {notification}
    }),

    removeNotification: (notification: Notification): AppAction => ({
        type: TYPES.REMOVE_NOTIFICATION,
        payload: {notification}
    }),

    setAcceptedAgeGate: (): AppAction => ({
        type: TYPES.SET_ACCEPTED_AGE_GATE
    }),

    trackEvent: (
        interactionType: string,
        eventCategory: string,
        eventAction: string,
        eventLabel: string,
        eventValue: string
    ): AppAction => ({
        type: TYPES.APP_TRACK_EVENT,
        payload: {interactionType, eventCategory, eventAction, eventLabel, eventValue}
    }),

    setClientExpired: (): AppAction => ({
        type: TYPES.SET_CLIENT_EXPIRED
    })
};
